"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _compositionsError = _interopRequireDefault(require("@eig-builder/compositions-error"));

/**
 * Component that can be used as a fallback for when an error occurs.
 */
var Error = function Error(_ref) {
  var history = _ref.history;

  var onButtonClick = function onButtonClick() {
    history.goBack();
  };

  return /*#__PURE__*/_react["default"].createElement(_compositionsError["default"], {
    onClick: onButtonClick
  });
};

Error.propTypes = {
  history: _propTypes["default"].object.isRequired
};

var _default = (0, _reactRouterDom.withRouter)(Error);

exports["default"] = _default;